var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sl-loader text-center"},[_c('div',{staticClass:"sl-loader-spinner"},[_c('i',{staticClass:"fa fa-spinner fa-spin"})])])
}]

export { render, staticRenderFns }